import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import React, { Component } from "react";
import Slider from "react-slick";
import { Card } from "react-bootstrap";

export default class SimpleSlider extends Component {

    state = {
        data: []
    }
    async componentDidMount() {
        try {
            const res = await fetch('http://localhost:5000/revew');
            const data = await res.json()
            console.log(data);
            this.setState({ data: data })
        } catch (error) {
            console.log(error);
        }

    }
    render() {
        const { data } = this.state
        const settings = {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1
        };
        return (
            <div className='my-5' >
                <div className="container">
                 
                    <Slider {...settings}>
                        {
                            data.map(item => {
                                return <div className="">
                                    <Card style={{ width: '18rem' }}>
                                        <h4>{item?.name} </h4>
                                        <div className="card-body">
                                            <h5 className="card-title text-light fs-3 fw-normal">{item.name}</h5>
                                            <p className="card-text text-Info fs-5 text-white">{item.desc.slice(0, 130)}</p>

                                        </div>
                                    </Card>
                                </div>
                            })
                        }
                    </Slider>
                </div>
            </div>
        );
    }
}